import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import CheckMark from '../../../assets/images/grey-check-icon.svg';

import { OfferOption } from '../../utils/backend-api/subscribe';
import { SelectedOffer } from '../../utils/backend-api/subscribe';
import { YOUNG_PROFESSIONALS_PLAN } from '../../utils/subscriptionCardOptions';
import Offers from './Offers';

interface SingleOffersProps {
  description?: string;
  offer: OfferOption;
  selectedOffer: SelectedOffer;
}

const BENEFITS = [
  'Read in-depth stories you won’t find anywhere else',
  'Subscribe to our suite of newsletters',
  'Attend monthly live events',
  'Read on the go with The Information app',
];

const SingleOffer = ({ description, offer, selectedOffer }: SingleOffersProps) => {
  const isYPPlan = offer.code.includes(YOUNG_PROFESSIONALS_PLAN);

  return (
    <div>
      <div
        className={clsx('h-min-auto', {
          'sm:min-h-[132px]': isYPPlan,
          'sm:min-h-[188px]': !isYPPlan,
        })}
      >
        <h2 className="mb-20 mt-24 font-serif font-normal">{ReactHtmlParser(offer.header)}</h2>
        <p className="font-serif text-body-lg text-gray-600">
          {description || ReactHtmlParser(offer.subHeader)}
        </p>
      </div>
      <div className="mb-20 mt-24 flex items-center">
        <div className="font-sans text-body-sm font-bold uppercase text-primary-red">
          Special Offer
        </div>
        <div className="ml-12 h-2 flex-1 bg-primary-red"></div>
      </div>
      <Offers offers={[offer]} selectedOfferCode={selectedOffer.code} />
      <div className="mt-32">
        {BENEFITS.map((benefit, index) => (
          <div key={index} className="mb-8 flex items-center font-sans text-grayscale-80">
            <img src={CheckMark} className="mr-8" />
            <div className="w-full border-0 border-b border-solid border-neutral-200 py-4">
              {benefit}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleOffer;
